import { Star } from "lucide-react";

const reviews = [
    {
        name: "Anjali R.",
        loc: "Bengaluru",
        text: "The Chikmagalur trip was smooth from start to finish. Driver was kind, resort was lovely, and the itinerary respected our budget. Will book again!",
    },
    {
        name: "Prakash M.",
        loc: "Shivamogga",
        text: "Booked an outstation cab at midnight — they answered instantly. Fair fare, clean car, and a polite driver. This is why locals recommend them.",
    },
    {
        name: "Ravi & Family",
        loc: "Mysuru",
        text: "Four generations, one bus, zero complaints. They managed food stops, temple timings, and even a wheelchair for grandma. Truly helpful staff.",
    },
];

const Testimonials = () => {
    return (
        <section className="bg-[#1B3B2B] text-[#FAFAF5] py-24">
            <div className="mx-auto max-w-7xl px-5 md:px-10">
                <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6">
                    <h2 className="font-display text-4xl md:text-6xl leading-[1.05]">
                        Loved by Shivamogga.
                    </h2>
                    <div className="flex items-center gap-3">
                        <div className="flex gap-1">
                            {[0, 1, 2, 3, 4].map((i) => (
                                <Star
                                    key={i}
                                    className="h-5 w-5 fill-[#C46A42] text-[#C46A42]"
                                />
                            ))}
                        </div>
                        <span className="text-lg">5.0 / 23 reviews</span>
                    </div>
                </div>

                <div className="mt-14 grid gap-6 md:grid-cols-3">
                    {reviews.map((r, i) => (
                        <figure
                            key={i}
                            className="rounded-2xl bg-white/[0.06] backdrop-blur p-7 ring-1 ring-white/10 hover:bg-white/[0.09] transition-colors duration-300"
                        >
                            <div className="flex gap-1 mb-4">
                                {[0, 1, 2, 3, 4].map((s) => (
                                    <Star
                                        key={s}
                                        className="h-3.5 w-3.5 fill-[#C46A42] text-[#C46A42]"
                                    />
                                ))}
                            </div>
                            <blockquote className="font-display text-lg leading-relaxed italic">
                                “{r.text}”
                            </blockquote>
                            <figcaption className="mt-6 text-sm">
                                <div className="font-medium">{r.name}</div>
                                <div className="opacity-70">{r.loc}</div>
                            </figcaption>
                        </figure>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default Testimonials;
